// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2CxC4","title":"styles_title__11tGt","caption":"styles_caption__AfvVJ"};